<template>
    <Breadcrumbs main="Apps" title="Marketing's KYT" />
    <div class="container-fluid">
        <div class="email-wrap bookmark-wrap">
            <div class="row">
                <KytList />
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const KytList = defineAsyncComponent(() => import("@/components/kyts/list.vue"))
</script>